export const catalogosInitial = {
  catalogo: {
    categoria: "",
    elementos: [],
  },
  catalogos: [],
  categoriaSelected:0
};
